// extracted by mini-css-extract-plugin
export default {"animate":"TZD6gE","fadeIn":"bmL6HS","write":"KLchxd"};